module.exports = __webpack_public_path__ + "img/9efda04.webp";